import Stepper from "component/stepper/stepper"

interface GuestAgePolicyProps {
    freeChildAgeLimit: number
    chargeableChildAgeLimit: number
    onFreeChildAgeLimitChange: (value: number) => void
    onChargeableChildAgeLimitChange: (value: number) => void
}

const GuestAgePolicy = ({
    freeChildAgeLimit,
    chargeableChildAgeLimit,
    onFreeChildAgeLimitChange,
    onChargeableChildAgeLimitChange,
}: GuestAgePolicyProps) => {
    return (
        <>
            <b>Guest Age Policy Setup</b>
            <div className="age-policy-section">
                <div className="age-policy-row">
                    <label>Free Child Age Limit</label>
                    <Stepper
                        value={freeChildAgeLimit}
                        onChange={onFreeChildAgeLimitChange}
                        min={0}
                        max={18}
                        allowNegative={false}
                    />
                </div>
                <div className="age-policy-row">
                    <label>Chargeable Child Age Limit</label>
                    <Stepper
                        value={chargeableChildAgeLimit}
                        onChange={onChargeableChildAgeLimitChange}
                        min={0}
                        max={18}
                        allowNegative={false}
                    />
                </div>
            </div>
        </>
    )
}

export default GuestAgePolicy
